import { render, staticRenderFns } from "./InstructionsOtherForms.vue?vue&type=template&id=7af036b4&scoped=true"
import script from "./InstructionsOtherForms.vue?vue&type=script&lang=ts"
export * from "./InstructionsOtherForms.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=7af036b4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af036b4",
  null
  
)

export default component.exports